export enum AccountEvents {
  LOGIN = 'login',
  LOGIN_EMAIL = 'email',
  LOGIN_FACEBOOK = 'facebook_sso',
  LOGOUT = 'logout',
  CREATE_NEW_ACCOUNT = 'sign_up',
  CLICKED_SNEAK_PREVIEW = 'sneak_preview',
  AUTH_TOKEN = 'authenticate_with_token',
  LOGIN_GOOGLE = 'google_sso',
  RESEND_VERIFICATION_EMAIL = 'resend_verification_email',
  VERIFY_EMAIL = 'verify_email',
}

export enum ButtonClickTypes {
  AUTH_GOOGLE = 'authenticate_with_google',
  AUTH_FACEBOOK = 'authenticate_with_facebook',
}

export enum LoginType {
  FACEBOOK = 'facebook',
  EMAIL = 'email',
  GOOGLE = 'google',
  SWITCH_PROFILE = 'switch_profile',
}
